import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';

import { catchError, mergeMap, Observable, of } from 'rxjs';

import { User } from '@app/shared/models/user.model';

import { LoginDialogComponent } from '../dialogs/login/login-dialog.component';
import { getData, verifyServerResult } from '../../../../libs/shared/src/lib/operators';
import { ServerResult } from '../../../../libs/shared/src/lib/models/server-result.model';
import { APP_ENVIRONMENT } from '@app/shared/tokens';

export const AuthenticatedGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    modal = inject(MatDialog),
    http = inject(HttpClient),
    env = inject(APP_ENVIRONMENT)
): Observable<boolean | UrlTree> => {
    return http.get<ServerResult<User>>(`${env.serverUrl}/auth/users/me`).pipe(
        verifyServerResult(),
        getData(),
        mergeMap(result => {
            if (!result) {
                return modal
                    .open(LoginDialogComponent)
                    .afterClosed()
                    .pipe(
                        mergeMap(isAuthenticated => {
                            if (isAuthenticated) {
                                return of(true);
                            }

                            return of(false);
                        }),
                    );
            }

            return of(true);
        }),
        catchError(() => {
            return of(false);
        }),
    );
};
